import React, { useEffect, useMemo, useState } from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Dialog,
    DialogContent,
    DialogTitle,
    Typography,
    Box,
    IconButton,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';

const LEVEL_ITEMS = [
    // { key: '01', label: 'กรมควบคุมโรค' },
    { key: '02', label: 'เขตสุขภาพ' },
    { key: '03', label: 'จังหวัด' },
    { key: '04', label: 'อำเภอ' },
    { key: '05', label: 'ตำบล' },
];

const normalizeLevel = (value) => {
    const stringValue = String(value ?? '01');
    const matched = LEVEL_ITEMS.find((item) => item.key === stringValue);
    return matched ? matched.key : '01';
};

export default function EOCLevelDialog({
    open = false,
    onClose,
    eoc_level = '01',
    title = 'เกณฑ์การเปิดศูนย์ปฏิบัติการตอบโต้ภาวะฉุกเฉิน โรคไข้เลือดออก',
}) {
    const [expanded, setExpanded] = useState(normalizeLevel(eoc_level));

    useEffect(() => {
        if (!open) {
            setExpanded(false);
            return;
        }

        setExpanded(normalizeLevel(eoc_level));
    }, [open, eoc_level]);

    const activeLevel = useMemo(() => normalizeLevel(eoc_level), [eoc_level]);

    const handleAccordionChange = (panel) => (_, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ pb: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
                    {title}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    edge="end"
                    sx={{
                        color: 'text.secondary',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 0 }}>
                <Box sx={{ p: 1 }}>
                    {LEVEL_ITEMS.map((item) => {
                        const isCurrentLevel = activeLevel === item.key;
                        const isExpanded = expanded === item.key;

                        return (
                            <Accordion
                                key={item.key}
                                expanded={isExpanded}
                                onChange={handleAccordionChange(item.key)}
                                disableGutters
                                elevation={0}
                                sx={{
                                    '&:before': { display: 'none' },
                                    border: '1px solid',
                                    borderColor: isExpanded ? 'primary.main' : 'divider',
                                    borderRadius: '12px !important',
                                    mb: 1,
                                    overflow: 'hidden',
                                    backgroundColor: isCurrentLevel ? 'rgba(205, 108, 74, 0.04)' : 'inherit',
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel-${item.key}-content`}
                                    id={`panel-${item.key}-header`}
                                    sx={{
                                        minHeight: '52px',
                                        '& .MuiAccordionSummary-content': {
                                            my: 1,
                                        },
                                    }}
                                >
                                    <Typography
                                        variant="subtitle1"
                                        sx={{
                                            fontWeight: isExpanded ? 700 : 500,
                                            color: isCurrentLevel ? 'primary.main' : 'text.primary',
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ borderTop: '1px solid', borderColor: 'divider', bgcolor: 'rgba(0,0,0,0.01)', p: 0 }}>


                                    {/* {item.key === '01' && (
                                        <>
                                            <Typography variant="body2" sx={{ fontWeight: 600, m:1}}>พิจารณาการเปรียบเทียบจาก Med หรือ จำนวนที่เข้าเกณฑ์เปิด</Typography>
                                            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr 1fr', borderCollapse: 'collapse' }}>
                                                <Box sx={{ borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'divider', p: 1.5, backgroundColor: '#f8f8f8' }}>
                                                    <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary' }}>
                                                        ระดับภาวะฉุกเฉิน
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'divider', p: 1.5, backgroundColor: '#f8f8f8' }}>
                                                    <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary' }}>
                                                        มีผู้ป่วยมากกว่า Med 5 ปี
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', p: 1.5, backgroundColor: '#f8f8f8' }}>
                                                    <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary' }}>
                                                        มีเขตเข้าเกรณฑ์เปิด EOC
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>1 (Alert Mode)</Typography>
                                                </Box>
                                                <Box sx={{ borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                                    <Typography variant="body2">ค่าเกิน Med ต่อเนื่อง 4 สัปดาห์</Typography>
                                                </Box>
                                                <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                                    <Typography variant="body2">2 เขต</Typography>
                                                </Box>
                                                <Box sx={{ borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>2 (Response 1)</Typography>
                                                </Box>
                                                <Box sx={{ borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                                    <Typography variant="body2">เกินร้อยละ 20</Typography>
                                                </Box>
                                                <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                                    <Typography variant="body2">3 เขต</Typography>
                                                </Box>
                                                <Box sx={{ borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>3 (Response 2)</Typography>
                                                </Box>
                                                <Box sx={{ borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                                    <Typography variant="body2">เกินร้อยละ 50</Typography>
                                                </Box>
                                                <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                                    <Typography variant="body2">6 เขต</Typography>
                                                </Box>
                                                <Box sx={{ borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>4 (Response 3)</Typography>
                                                </Box>
                                                <Box sx={{ borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                                    <Typography variant="body2">เกินร้อยละ 80</Typography>
                                                </Box>
                                                <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                                    <Typography variant="body2">7 เขตขึ้นไป</Typography>
                                                </Box>
                                            </Box>
                                        </>
                                    )} */}

                                    {item.key === '02' && (
                                        <>
                                            <Typography variant="body2" sx={{ fontWeight: 400, m: 2}}>มีจังหวัดที่เข้าเกณฑ์เปิด EOC มากกว่าร้อยละ 25 ของจำนวนจังหวัดในเขตสุขภาพ หรือมีการระบาดสูงกว่าค่า Med ย้อนหลัง 5 ปีต่อเนื่องมากกว่า 4 สัปดาห์</Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 400, m: 2}}><span className='font-bold'>หมายเหตุ</span> - สคร.ที่มีจังหวัดน้อยกว่า 5 จังหวัด พิจารณายกระดับเมื่อมีจังหวัดที่เข้าเกณฑ์ ยกระดับ EOC ตั้งแต่ 3 จังหวัดขึ้นไป  </Typography>
                                        </>
                                    )}

                                    {item.key === '03' && (
                                        <>
                                            <Typography variant="body2" sx={{ fontWeight: 400, m: 2}}>มีอำเภอเข้าเกณฑ์เปิด EOC มากกว่าร้อยละ 25 ของจำนวนอำเภอในจังหวัด หรือมีการระบาดสูงกว่าค่า Med ย้อนหลัง 5 ปีต่อเนื่องมากกว่า 4 สัปดาห์</Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 400, m: 2}}><span className='font-bold'>หมายเหตุ</span> - จังหวัดที่มีอำเภอน้อยกว่า 5 อำเภอ พิจารณายกระดับเมื่อมีอำเภอที่เข้าเกณฑ์ ยกระดับ EOC ตั้งแต่ 3 อำเภอขึ้นไป  </Typography>
                                        </>
                                    )}

                                    {item.key === '04' && (
                                        <>
                                            <Typography variant="body2" sx={{ fontWeight: 400, m: 2}}>มีตำบลที่เป็นพื้นที่ระบาด มากกว่าร้อยละ 25 ของจำนวนตำบลในอำเภอ </Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 400, m: 2}}><span className='font-bold'>ตำบลที่เป็นพื้นที่ระบาด</span> - หมายถึง ตำบลที่มีรายงานผู้ป่วยโรคไข้เลือดออกเกินค่ามัธยฐาน 5 ปีย้อนหลัง ในช่วง 4 สัปดาห์ล่าสุด และมีการระบาดต่อเนื้่องมากกว่า 28 วัน (พบผู้ป่วยรายใหม่ต่อเนื่องกัน โดยวันที่พบผู้ป่วย (วันที่วินิจฉัยสงสัยไข้เลือดออก) ของผู้ป่วยแต่ละรายทิ้งระยะห่างกันไม่เกิน 28 วัน และยังควบคุมโรคไม่ได้)</Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 400, m: 2}}><span className='font-bold'>4 สัปดาห์</span> - หมายถึง 4 สัปดาห์ล่าสุดซี่งไม่นับสัปดาห์ปัจจุบัน</Typography>
                                        </>
                                    )}

                                    {item.key === '05' && (
                                        <>
                                            <Typography variant="body2" sx={{ fontWeight: 400, m: 2}}>ตำบลที่มีรายงานผู้ป่วยโรคไข้เลือดออกเกินค่ามัธยฐาน 5 ปีย้อนหลัง ในช่วง 4 สัปดาห์ล่าสุด และมีการระบาดต่อเนื้่องมากกว่า 28 วัน (พบผู้ป่วยรายใหม่ต่อเนื่องกัน โดยวันที่พบผู้ป่วย (วันที่วินิจฉัยสงสัยไข้เลือดออก) ของผู้ป่วยแต่ละรายทิ้งระยะห่างกันไม่เกิน 28 วัน และยังควบคุมโรคไม่ได้)</Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 400, m: 2}}><span className='font-bold'>4 สัปดาห์</span> - หมายถึง 4 สัปดาห์ล่าสุดซี่งไม่นับสัปดาห์ปัจจุบัน</Typography>
                                        </>
                                    )}
                                </AccordionDetails>
                            </Accordion>
                        );
                    })}
                </Box>
            </DialogContent>
        </Dialog >
    );
}
